import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { BRANDS_CATEGORY_ID } from "@faire/help-center-utils/consts/BRANDS_CATEGORY_ID";
import { CATEGORY_ID } from "@faire/help-center-utils/consts/CATEGORY_ID";
import { RETAILERS_CATEGORY_ID } from "@faire/help-center-utils/consts/RETAILERS_CATEGORY_ID";
import { CustomerTypes } from "@faire/help-center-utils/enums/CustomerType";
import { useAboutFaireArticles } from "@faire/help-center-utils/hooks/article/useAboutFaireArticles";
import { sortByOrderList } from "@faire/help-center-utils/lib/arrayFormatter";
import { getLatestDataUpdatedAt } from "@faire/help-center-utils/lib/getLatestDataUpdatedAt";
import { localeString } from "@faire/help-center-utils/lib/localeString";
import { categoryPlaceholder, guidesPlaceHolder, popularGuidesPlaceHolder, sectionsPlaceHolder } from "@faire/help-center-utils/lib/random";
import { toArticleWithPreview } from "@faire/help-center-utils/lib/topics";
import { getBrand } from "@faire/help-center-utils/serialized-data/getBrand";
import { getRetailer } from "@faire/help-center-utils/serialized-data/getRetailer";
import { useQuery as useZendeskCategories } from "@faire/web-api/api/zendesk/locale/categories/get-hooks";
import { useQuery as useZendeskSections } from "@faire/web-api/api/zendesk/locale/sections/get-hooks";
import { isNotUndefined } from "@faire/web/common/typescriptUtils";
import { useMemo } from "react";
import { isHiddenSection } from "../consts";
import { useAllCategoryArticles } from "./useAllCategoryArticles";
import { useAllSectionArticles } from "./useAllSectionArticles";
import { useCustomerType } from "./useCustomerType";
export var useSectionStore = function useSectionStore() {
  var _categoriesResponse$c;
  var _useZendeskCategories = useZendeskCategories(localeString),
    categoriesResponse = _useZendeskCategories.data,
    isCategoriesFetching = _useZendeskCategories.isFetching,
    categoriesDataUpdatedAt = _useZendeskCategories.dataUpdatedAt;
  var _useZendeskSections = useZendeskSections(localeString),
    sectionsResponse = _useZendeskSections.data,
    isSectionsFetching = _useZendeskSections.isFetching,
    sectionsDataUpdatedAt = _useZendeskSections.dataUpdatedAt;
  var categories = (_categoriesResponse$c = categoriesResponse === null || categoriesResponse === void 0 ? void 0 : categoriesResponse.categories) !== null && _categoriesResponse$c !== void 0 ? _categoriesResponse$c : [];
  var sections = useMemo(function () {
    var _sectionsResponse$sec;
    return (_sectionsResponse$sec = sectionsResponse === null || sectionsResponse === void 0 ? void 0 : sectionsResponse.sections.filter(function (section) {
      return !isHiddenSection(section.id);
    })) !== null && _sectionsResponse$sec !== void 0 ? _sectionsResponse$sec : [];
  }, [sectionsResponse]);
  var _useCustomerType = useCustomerType(),
    customerType = _useCustomerType.customerType;
  var _useAllCategoryArticl = useAllCategoryArticles(categories),
    categoriesArticlesResponses = _useAllCategoryArticl.categoriesArticlesResponses,
    isCategoriesArticlesLoading = _useAllCategoryArticl.isCategoriesArticlesLoading,
    categoriesArticlesDataUpdatedAt = _useAllCategoryArticl.categoriesArticlesDataUpdatedAt;
  var _useAllSectionArticle = useAllSectionArticles(sections),
    sectionArticlesResponses = _useAllSectionArticle.sectionArticlesResponses,
    isSectionArticlesLoading = _useAllSectionArticle.isSectionArticlesLoading,
    sectionArticlesDataUpdatedAt = _useAllSectionArticle.sectionArticlesDataUpdatedAt;
  var categoriesArticles = categories ? categories.map(function (category, index) {
    var _categoriesArticlesRe, _categoriesArticlesRe2;
    var articles = (categoriesArticlesResponses === null || categoriesArticlesResponses === void 0 ? void 0 : (_categoriesArticlesRe = categoriesArticlesResponses[index]) === null || _categoriesArticlesRe === void 0 ? void 0 : (_categoriesArticlesRe2 = _categoriesArticlesRe.data) === null || _categoriesArticlesRe2 === void 0 ? void 0 : _categoriesArticlesRe2.articles) || [];
    var number_of_articles = articles.filter(function (article) {
      return !article.draft;
    }).length || 0;
    return _objectSpread(_objectSpread({}, category), {}, {
      articles: articles,
      number_of_articles: number_of_articles
    });
  }) : [];
  var sectionsArticles = sections ? sections.map(function (section, index) {
    var _sectionArticlesRespo, _sectionArticlesRespo2;
    var articles = (sectionArticlesResponses === null || sectionArticlesResponses === void 0 ? void 0 : (_sectionArticlesRespo = sectionArticlesResponses[index]) === null || _sectionArticlesRespo === void 0 ? void 0 : (_sectionArticlesRespo2 = _sectionArticlesRespo.data) === null || _sectionArticlesRespo2 === void 0 ? void 0 : _sectionArticlesRespo2.articles) || [];
    var number_of_articles = articles.filter(function (article) {
      return !article.draft;
    }).length || 0;
    return _objectSpread(_objectSpread({}, section), {}, {
      articles: articles,
      number_of_articles: number_of_articles
    });
  }) : [];
  var isLoading = isCategoriesFetching || isSectionsFetching || isCategoriesArticlesLoading || isSectionArticlesLoading;
  var dataUpdatedAt = getLatestDataUpdatedAt([categoriesDataUpdatedAt, sectionsDataUpdatedAt, categoriesArticlesDataUpdatedAt, sectionArticlesDataUpdatedAt]);
  var loggedBrandType = getBrand() ? CustomerTypes.BRAND : undefined;
  var loggedUserType = getRetailer() ? CustomerTypes.RETAILER : loggedBrandType;
  var getCategory = function getCategory(customerType) {
    var _selectedCategory$art;
    if (isLoading || !categories) {
      return categoryPlaceholder;
    }
    var selectedCategory = categoriesArticles.find(function (category) {
      return category.id === CATEGORY_ID[customerType];
    });
    var articles = selectedCategory === null || selectedCategory === void 0 ? void 0 : (_selectedCategory$art = selectedCategory.articles) === null || _selectedCategory$art === void 0 ? void 0 : _selectedCategory$art.slice(0, 6).filter(function (article) {
      return !article.draft;
    });
    var sectionIds = sectionsArticles.map(function (section) {
      return section.id;
    }).filter(isNotUndefined);
    return _objectSpread(_objectSpread({}, selectedCategory), {}, {
      articles: articles === null || articles === void 0 ? void 0 : articles.sort(sortByOrderList("section_id", sectionIds))
    });
  };
  var retailerPopularGuides = getCategory(CustomerTypes.RETAILER);
  var brandPopularGuides = getCategory(CustomerTypes.BRAND);
  var getPopularGuides = function getPopularGuides() {
    var _categoriesArticles$f;
    if (isLoading) {
      return popularGuidesPlaceHolder;
    }
    return categoriesArticles === null || categoriesArticles === void 0 ? void 0 : (_categoriesArticles$f = categoriesArticles.find(function (category) {
      return category.id === CATEGORY_ID[customerType];
    })) === null || _categoriesArticles$f === void 0 ? void 0 : _categoriesArticles$f.articles;
  };
  var categoryId = customerType === CustomerTypes.BRAND ? BRANDS_CATEGORY_ID : RETAILERS_CATEGORY_ID;
  var sectionsWithArticles = sectionsArticles === null || sectionsArticles === void 0 ? void 0 : sectionsArticles.map(function (section) {
    var _section$articles;
    var articles = section === null || section === void 0 ? void 0 : (_section$articles = section.articles) === null || _section$articles === void 0 ? void 0 : _section$articles.filter(function (article) {
      return !article.draft;
    }).slice(0, 3);
    if ((articles === null || articles === void 0 ? void 0 : articles.length) === 0) {
      return undefined;
    }
    return _objectSpread(_objectSpread({}, section), {}, {
      articles: articles
    });
  }).filter(isNotUndefined);
  var allTopics = isLoading || !customerType ? sectionsPlaceHolder() : (sectionsWithArticles === null || sectionsWithArticles === void 0 ? void 0 : sectionsWithArticles.filter(function (section) {
    return section.category_id === categoryId;
  })) || [];
  var getGuides = function getGuides(selectedGuides) {
    if (isLoading) {
      return guidesPlaceHolder;
    }
    var selectedGuidesWithPreview = selectedGuides.map(function (selectedGuide) {
      var _selectedSection$arti;
      var selectedSection = sectionsArticles.find(function (section) {
        var _section$articles2;
        return (_section$articles2 = section.articles) === null || _section$articles2 === void 0 ? void 0 : _section$articles2.some(function (article) {
          return article.id === Number(selectedGuide.id);
        });
      });
      var selected = (selectedSection === null || selectedSection === void 0 ? void 0 : (_selectedSection$arti = selectedSection.articles) === null || _selectedSection$arti === void 0 ? void 0 : _selectedSection$arti.find(function (article) {
        return article.id === Number(selectedGuide.id);
      })) || {};
      return toArticleWithPreview(selected, selectedSection === null || selectedSection === void 0 ? void 0 : selectedSection.name);
    });
    return selectedGuidesWithPreview;
  };
  var aboutFaireArticles = useAboutFaireArticles();
  var aboutFaireSection = getGuides(aboutFaireArticles);
  return {
    isLoading: isLoading,
    categories: categoriesArticles,
    sections: sectionsArticles,
    loggedUserType: loggedUserType,
    retailerPopularGuides: retailerPopularGuides,
    brandPopularGuides: brandPopularGuides,
    getPopularGuides: getPopularGuides,
    getGuides: getGuides,
    aboutFaireSection: aboutFaireSection,
    allTopics: allTopics,
    dataUpdatedAt: dataUpdatedAt
  };
};